<template>
  <div class='filter'>
    <div class='title'>
      {{ label }}
      <div
        v-if='!isCity && checkedOptions.length'
        class='count'
      >
        {{ checkedOptions.length }}
      </div>
      <button
        v-if='isAdditionalOptions'
        class='button-text details'
        @click='emit("filter:details")'
      >
        {{ tp('details') }}<ChevronDownIcon />
      </button>
    </div>
    <div class='options'>
      <LabelButton
        v-for='option in sortedOptions.slice(0, optionsLimit)'
        :key='option.value'
        :is-active='option.isChecked'
        @click='toggleFilterOption(option)'
      >
        {{ option.label }}
        <span
          v-if='option.markerClass'
          :class='option.markerClass'
          :style='option.markerStyle'
        />
      </LabelButton>
      <LabelButton
        v-if='isAdditionalOptions'
        key='other'
        :is-active='isAdditionalCheckedOptions'
        @click='emit("filter:details")'
      >
        <template v-if='isAdditionalCheckedOptions'>
          +{{ checkedOptions.length - optionsLimit }}
        </template>
        <template v-else>
          ...
        </template>
      </LabelButton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterBlock'
};
</script>

<script setup>
import { computed } from 'vue';
import ChevronDownIcon from '@/../images/vue/storages_map-v4/filters_modal/chevron-down.svg?inline';
import { prepared } from '@/helpers/i18n';
import LabelButton from '../../components/label_button';

const props = defineProps({
  name: { type: String, required: true },
  isCity: { type: Boolean, required: true },
  label: { type: String, required: true },
  options: { type: Array, required: true }
});
const emit = defineEmits(['filter:details', 'filter:update']);
const tp = prepared('frontend.storages_map-v4.filters_modal.filter');

const FILTERS_LIMIT = 4;

const isAdditionalOptions = computed(() => (
  optionsLimit.value < props.options.length
));
const isAdditionalCheckedOptions = computed(() => (
  checkedOptions.value.length > optionsLimit.value
));
const isAllSelectedOptionsDisplayed = computed(() => (
  checkedOptions.value.length ===
    props.options
      .slice(0, optionsLimit.value)
      .filter(({ isChecked }) => isChecked).length
));

const checkedOptions = computed(() => (
  props.options.filter(({ isChecked }) => isChecked)
));

const sortedOptions = computed(() => (
  !isAdditionalOptions.value || isAllSelectedOptionsDisplayed.value ?
    props.options :
    [
      ...checkedOptions.value,
      ...props.options.filter(({ isChecked }) => !isChecked)
    ]
));

const optionsLimit = computed(() => (
  props.isCity ?
    props.options.length :
    FILTERS_LIMIT
));

function toggleFilterOption(option) {
  emit('filter:update', {
    filterName: props.name,
    option,
    isChecked: !option.isChecked
  });
}
</script>

<style scoped lang='sass'>
@import 'app/packs/stylesheets/functions/rem'
@import 'app/packs/stylesheets/mixins/typography'
@import 'app/packs/stylesheets/mixins/ltr_rtl'

.title
  +p3(700)
  color: #000
  display: flex
  gap: rem4(8px)
  margin-bottom: rem4(8px)

  .count
    font-weight: 400
    color: var(--gray-400)

.options
  display: flex
  flex-wrap: wrap
  gap: rem4(12px)

.details
  +margin-left_ltr(auto)
  gap: rem4(4px)

  svg
    transform: rotate(270deg)
</style>
